import React, { Component } from "react";
import { Modal, InputGroup, FormControl } from "react-bootstrap";
import { toast } from 'react-toastify';
// API Urls
import APIUrls from "../../constants/ApiUrls";
import { APIManager } from "../../utils/api";
import LoaderButton from "../../components/LoaderButton";
import "./Forgot.scss";

import CamelLogo from "../../assets/images/main-logo-white.png";

const modalStyle = () => {
  // we use some psuedo random coords so nested modals
  // don't sit right on top of each other.
  let top = window.innerHeight / 2 - 214;
  let left = window.innerWidth / 2 - 230;

  return {
    position: 'fixed',
    width: 460,
    zIndex: 1040,
    top: top + 'px',
    bottom: top + 'px',
    left: left + 'px',
  };
};

const emailRule = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default class Forgot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: null,
      error: null,
      isSuccess: false,
    }
  }

  onClickReset = async () => {
    if (!emailRule.test(this.state.email)) {
      this.setState({ error: 'Please input correct email address' });
      return;
    }

    this.setState({ isLoading: true, isSuccess: false });
    
    try {
      await APIManager.Instance.call("GET", APIUrls.resetPassword(this.state.email));
      this.setState({ isSuccess: true, isLoading: false });

      toast.success('Sent reset link successfully!', {
        position: toast.POSITION.TOP_RIGHT
      });
    } catch (e) {
      this.setState({ error: e.message, isLoading: false });

      toast.error('Failed to send reset link:' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  onChangeEmail = (e) => {
    this.setState({ email: e.target.value, error: null });
  }

  render() {
    const { isLoading, isSuccess } = this.state;

    return (
      <div className="forgot-password">
        <Modal
          onHide={this.close}
          style={modalStyle()}
          aria-labelledby="modal-label"
          show={true}
          className="forgot"
        >
          <div className="modal-header">
            <img src={CamelLogo} alt="camel logo" />
          </div>
          <div className="content p-5">
            <h3>Forgot your password?</h3>
            <p className="sub-title">We can send a reset link to your email.</p>
            <div className="description">
              <p className="mb-0">Check your email shortly after requesting a reset.</p>
            </div>
            <InputGroup className="mb-4">
              <InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1">email</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                placeholder="Your email address"
                aria-label="Email Address"
                aria-describedby="basic-addon1"
                onChange={this.onChangeEmail}
              />
            </InputGroup>
            <LoaderButton
              block
              type="submit"
              isLoading={isLoading}
              text={isSuccess ? "SEND RESET LINK AGAIN" : "RESET PASSWORD"}
              loadingText="SEND EMAIL..."
              className="btn-danger"
              onClick={this.onClickReset}
            />
            {isSuccess && <p className="mt-2" style={{ color: 'green' }}>Please check your inbox now.</p>}
            {this.state.error && <p className="mt-2" style={{ color: 'red' }}>{this.state.error}</p>}
          </div>
        </Modal>
      </div>
    );
  }
}
